import React from 'react';
import Article from './article';
import NewsApi from '../data/mockNewsApi';
import Copyright from '../components/copyright';

class FullArticle extends React.Component {
    constructor(props) {
        super(props);

        const news = NewsApi.getArticle(this.props.tag)
        this.state = { article: news };
    }

    // const article = NewsApi.getArticle(this.props.tag)
    render() {
        return(
            <div>
              <Article title={this.state.article.title} content={this.state.article.content} />
              <br/>
              <Copyright copyholder='Ol&#039; Dawg.com' />
            </div>
        );
    };
}

export default FullArticle;